import { all } from 'redux-saga/effects';
import { onFetchTourAvailability } from '@state/tours/tour-availability/tourAvailabilityOperations';
import { onFetchTourDossiers } from '@state/tours/tour-dossiers/tourDossiersOperations';
import { onFetchTourRooms, onPutTourRooms } from '@state/tours/tour-rooms/tourRoomsOperations';

export function* combinedTourSagas() {
  yield all([onFetchTourAvailability(), onFetchTourDossiers(), onFetchTourRooms(), onPutTourRooms()]);
}
